import { css } from 'styled-components';
import brand from './brand';
export const rootMargin = '0px 0px -33% 0px';
export const cubicEaseOut = `cubic-bezier(0.33, 1, 0.68, 1)`;
export const shouldAnimate = (innerCss) => {
    return css `
    @media (prefers-reduced-motion: no-preference) {
      ${innerCss}
    }
  `;
};
export const transition = (properties, duration = 0.35, timing = cubicEaseOut) => {
    return shouldAnimate(css `
    transition-duration: ${typeof duration === 'string' ? duration : `${duration}s`};
    transition-property: ${properties};
    transition-timing-function: ${timing};
    will-change: ${properties};
  `);
};
const TITLE_FILL_SPEED = '0.1s';
export const titleFill = shouldAnimate(css `
  @supports (background-clip: text) or (-webkit-background-clip: text) {
    ${transition('opacity, background-size', `0.25s, var(--duration, calc(var(--length) * var(--speed, ${TITLE_FILL_SPEED})))`)}
    transition-delay: var(--delay, 0.15s), calc(var(--delay, 0.15s) * 2);

    display: inline;
    -webkit-background-clip: text;
    background-clip: text;
    background-color: var(--textColor, ${brand.white});
    background-image: linear-gradient(
      to right,
      var(--fillColor, ${brand.yellow}),
      var(--fillColor, ${brand.yellow})
    );
    background-repeat: no-repeat;
    background-size: 0% 100%;
    color: transparent;
    opacity: 0;

    [data-animate='true'] & {
      background-size: 100% 100%;
      opacity: 1;
    }
  }
`);
